/* projects/speaker-platform/src/app/organisms/planning/planning.component.scss */
.planning__daylabels {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.planning__days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  row-gap: 16px;
}
.planning__day {
  cursor: pointer;
  transition: all 0.15s;
  background-color: #fff;
}
.planning__day--seance,
.planning__day--seanceextra {
  background-color: #99FF74;
  color: #289526;
}
.planning__day--dayoff {
  background-color: #ADADAD;
  color: #575757;
}
.planning__day__unavailable {
  background-color: inherit;
  color: inherit;
}
.planning__day--regularabsence {
  background-color: #FFC107;
  color: #9A7407;
}
.planning__day--sick {
  background-color: #FF7474;
  color: #952626;
}
.planning__day--onsite {
  background-color: #74E4FD;
  color: #dadada;
}
.planning__day--selected {
  transform: scale(1.2);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 5px;
}
.planning__today__title {
  margin-bottom: 16px;
  color: #818181;
  font-style: italic;
}
.planning__today__loader {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(3);
  z-index: 999;
}
.planning__today__details {
  position: relative;
}
.planning__today__details--loading {
  filter: blur(5px);
}
.planning__today__details__nodetails {
  font-size: 14px;
  font-style: italic;
  color: #818181;
}
/*# sourceMappingURL=planning.component-OYZRDPSU.css.map */
